Wee.fn.make('hero', {
	init: function() {
		var $priv = this.$private,
			$hero = $('ref:productCategoryHero');

		// Is there a product category hero and does it have a data-src attribute?
		if ($hero.length && $hero[0].hasAttribute('data-src')) {
			$priv.setBreakpoint();
			$priv.chooseImg();

			this.$observe('breakpoint', function() {
				$priv.chooseImg();
			});

			$($._win).on('resize.hero', function() {
				$priv.setBreakpoint();
			});
		}
	},
	pop: function() {
		$.events.off(false, '.hero');
	}
}, {
	/**
	 * Update breakpoint
	 *
	 * @private
	 */
	setBreakpoint: function() {
		this.$set('breakpoint', $($._win).width() > 375 ? 'desktop' : 'mobile');
	},

	/**
	 * Choose image
	 *
	 * @private
	 */
	chooseImg: function() {
		var $hero = $('ref:productCategoryHero'),
			$imgUrl = this.$get('breakpoint') === 'desktop' ? $hero.data('src') : $hero.data('mobile-src');

		$hero.css('background-image', 'url("' + $imgUrl + '")');
	}
});
